import { Component, OnInit, Input } from '@angular/core';
import { tPrescriptionHeadModel } from 'src/app/models/tPrescriptionHeadModel';
import { tPrescriptionLineModel_withStock } from 'src/app/models/tPrescriptionLineModel';
import { tConsultHeadModelWithPatientInfo } from 'src/app/models/tConsultHeadModel';
import { SystemDefaultModel, ChineseDefaultModel, EnglishDefaultModel } from 'src/app/models/non-master-model/SystemDefaultModel';
import { AppComponent } from 'src/app/app.component';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DateTimeConvertService } from 'src/app/services/CommonService/DateTimeConvert.service';
import { tOnConsultService } from 'src/app/services/tOnConsult.service';
import { isNullOrUndefined } from 'util';
import { MatTableDataSource } from '@angular/material';
import { DatePipe } from '@angular/common';
import { AppSettings } from 'src/app/shared/AppSettings';
import { tShopService } from 'src/app/services/tShop.service';
import { NavigationComponent } from 'src/app/pages/navigation/navigation.component';
import { tPrescriptionService } from 'src/app/services/tPrescription.service';
import { CrypService } from 'src/app/services/Non-Master/Cryp.service';
import { tShopModel } from 'src/app/Models/tShopModel';

@Component({
  selector: 'app-xray-label',
  templateUrl: './xray-label.component.html',
  styleUrls: ['./xray-label.component.css']
})
export class XrayLabelComponent implements OnInit {
  TAG = 'XrayLabelComp';

  @Input() consultNumber: string;
  @Input() shopID: string;

  p = {
    consultation:{
      clthConsultNumber:"",
      clthTherapistID:"",
      therapistName:"",
      clthDiagonsis:"",
      clthArrivalDate:"",
      xrayItems:["A","B"]
    },
    patient:{
      patientID:"",
      name:"",
      surname:"",
      dob:"",
      hkid:"",
      hkidDesc:"",
      registeredDate:"",
      caseDrID:"",
      gender:"",
      age:""
    },
    pDetails:[]
  };

  constructor(
    private router: Router,
    public activeModal: NgbActiveModal,
    private tOnConsultService: tOnConsultService,
    private dateTimeConvertService: DateTimeConvertService,
    public datepipe: DatePipe,
    private tShopService: tShopService,
    private tPrescriptionService:tPrescriptionService,
    private crypService: CrypService
    ) { }

  ngOnInit() {
    this.getXrayLabelPrint();
    this.getShopInfo();
  }

  getXrayLabelPrint(){
    this.tOnConsultService
      .getPrintXrayLabel(this.shopID, this.consultNumber)
      .subscribe((x) => {
        this.p = x.data;
        this.p.patient.hkid = this.crypService
          .decryptStr(this.p.patient.hkid)
          .toString();
      });
  }

  cancel() {
    // this.log.i(this.TAG, "do cancel");
    this.activeModal.close('Close click');
  }

  formatDate(date: Date) {
    const newDate = new Date(date);

    return this.datepipe.transform(date, 'yyyy/MM/dd');
  }

  shopInfo:tShopModel;

  getShopInfo(){
    this.tShopService.getDataById(this.shopID).subscribe(x=>this.shopInfo = x);
  }

}
